import { render, staticRenderFns } from "./sidebar-list.vue?vue&type=template&id=452dcd1a"
import script from "./sidebar-list.vue?vue&type=script&lang=js"
export * from "./sidebar-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports